import BsModal from "bootstrap/js/dist/modal";
import { autorun, makeAutoObservable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { h, render } from "preact";
import { useEffect } from "preact/hooks";
import { Sentry, debugAvailability, makeImmutable, } from "restaumatic-client/src";
import * as Modals from "../../utils/Modals";
import { hideModalBs5 } from "../../utils/modal";
import Creator from "./Creator";
import { scrollToError } from "../../utils/Scroll";
export function init(options) {
    console.log("Initializing new ProductCard");
    const modalElement = document.createElement("div");
    modalElement.id = "product-creator";
    modalElement.classList.add("m-product-card", "modal", "fade");
    modalElement.tabIndex = -1;
    document.body.appendChild(modalElement);
    const state = new ModalState();
    render(h(CreatorModal, { state: state }), modalElement);
    const modal = BsModal.getOrCreateInstance(modalElement);
    state.hideModal = () => modal.hide();
    return (productCardCreator) => {
        modal.show();
        runInAction(() => {
            state.productCard = new ProductCardState({
                creator: productCardCreator,
                addToCart: (creatorResult) => {
                    Modals.setNextModalShouldReplaceHash();
                    // TODO: switch to async/await once transpilation is sorted out
                    hideModalBs5(modalElement).then(() => {
                        options.addToCart(creatorResult);
                    });
                },
            });
        });
    };
}
class ModalState {
    constructor() {
        this.hideModal = () => { };
        this.productCard = null;
        makeAutoObservable(this);
    }
    close() {
        this.hideModal();
    }
}
export class ProductCardState {
    constructor(params) {
        this.creator = params.creator;
        this.addToCart = params.addToCart;
        makeImmutable(this);
    }
    /**
     * Update location.hash based on creator state
     */
    updateHash() {
        const productTypeIds = this.creator.productTypeIdValues.join("/");
        const hash = `#product/${productTypeIds}`;
        if (location.hash !== hash) {
            history.replaceState(null, "", window.location.pathname + hash);
        }
    }
    finish() {
        const result = this.creator.finish();
        if (result !== null) {
            this.addToCart(result);
        }
        else {
            scrollToError("#product-creator", [
                ".alert-danger",
                ".alert-warning",
                ".has-error",
            ]);
            // Send debug info
            const debug = debugAvailability(this.creator.availability);
            Sentry.logError("Add to cart validation error", {
                extra: {
                    unavailabilityReasons: debug.reasons,
                    availabilityErrors: debug.errors,
                },
            });
        }
    }
}
const CreatorModal = observer(({ state }) => {
    useEffect(() => autorun(() => {
        if (state.productCard) {
            state.productCard.updateHash();
        }
    }), [state]);
    return (h("div", { className: "modal-dialog" },
        h("div", { className: "modal-content" }, state.productCard ? h(Creator, { productCard: state.productCard }) : null)));
});
